"use client";

import { useEffect } from "react";
import Rollbar from "rollbar";
import { rollbarClientConfig } from "@/lib/rollbar";

const rollbar = new Rollbar(rollbarClientConfig);

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    rollbar.error("Unhandled route error", error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-plantista-50 dark:bg-plantista-950">
      <div className="text-center space-y-4 p-8">
        <h2 className="text-2xl font-display font-bold text-plantista-950 dark:text-plantista-50">
          Something went wrong
        </h2>
        <p className="text-plantista-600 dark:text-plantista-400">
          An unexpected error occurred. Our team has been notified.
        </p>
        <button
          onClick={reset}
          className="px-6 py-2 bg-plantista-600 text-white rounded-lg hover:bg-plantista-700 transition-colors font-sans"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
